import React from 'react';
import Hero from './Hero';
import NavbarStandard from './NavbarStandard';
import Processes from './Processes';
import Services from './Services';
import LandingPricing from './LandingPricing';
import LandingBlog from './LandingBlog';
import LandingFaq from './LandingFaq';
import Cta from './Cta';
import FooterStandard from './FooterStandard';

const Landing = () => {
  return (
    <>
      <NavbarStandard />
      <Hero />
      <Services />
      <Processes />
      <LandingPricing />
      <LandingFaq />
      <LandingBlog />
      <Cta />
      <FooterStandard />
    </>
  );
};

export default Landing;
